import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteParkingGateCodeMutation } from "modules/ParkingGateCodesDashboard/components/DeleteParkingGateCodeModal/hooks";

type DeleteParkingGateCodeModalProps = {
  parkingGateCodeId: number | null;
  onResetDeleteParkingGateCodeId: () => void;
};

export const DeleteParkingGateCodeModal = ({ parkingGateCodeId, onResetDeleteParkingGateCodeId }: DeleteParkingGateCodeModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteParkingGateCode, isPending } = useDeleteParkingGateCodeMutation();

  const handleDeleteParkingGateCode = async () => {
    if (!parkingGateCodeId) return;

    await deleteParkingGateCode(parkingGateCodeId);
    onResetDeleteParkingGateCodeId();
  };

  return (
    <CustomConfirm
      type={CUSTOM_CONFIRM_TYPES.Danger}
      isOpen={parkingGateCodeId !== null}
      isLoading={isPending}
      handleCancel={onResetDeleteParkingGateCodeId}
      handleConfirm={handleDeleteParkingGateCode}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
    />
  );
};
